import { Resource } from 'json-api-hooks';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form';

import { FormFieldDefinition } from './ResourceForm';

export enum InputType {
  AssociationInput = 'association',
  Checkbox = 'checkbox',
  Checkboxes = 'checkboxes',
  Date = 'date',
  DateTime = 'datetime',
  Description = 'description',
  Email = 'email',
  File = 'file',
  Hidden = 'hidden',
  Location = 'location',
  Number = 'number',
  OTP = 'otp',
  Password = 'password',
  PostalRange = 'postalRange',
  RadioGroup = 'radioGroup',
  RichText = 'richText',
  Search = 'search',
  Select = 'select',
  Slider = 'slider',
  Telephone = 'tel',
  Text = 'text',
  TextArea = 'textArea',
  ToggleGroup = 'toggleGroup',
}

type AllInputProps = ControllerRenderProps<Record<string, any>, string>;
export type InputProps = Partial<AllInputProps> & Pick<AllInputProps, 'value' | 'onChange'>;

export type InputRenderer = Partial<FormFieldDefinition<void>> & {
  fieldState?: ControllerFieldState;
  index?: number;
  inputProps: InputProps;
  resource?: Resource;
  storageKey?: string;
  size?: 'small' | 'medium';
};
